export default {
  namespaced: true,
  state: {
    isError: false,
    errorMessage: '',
  },
  mutations: {
    SET_NO_DATA(state, data) {
      state.isError = data;
    },
    SET_ERROR_MESSAGE(state, data) {
      state.errorMessage = data;
    },
  },
  actions: {
    setNoData({ commit }, data) {
      commit('SET_NO_DATA', data);
    },
    setErrorMessage({ commit }, data) {
      commit('SET_ERROR_MESSAGE', data);
    },
  },
}